// Registers sway-capable props (trees, flowers) and animates them each frame
// as if a light, always-on wind is blowing. The base placement rotation is
// preserved — we only touch the inner sway group.

const swayables = [];

export function registerSwayable(obj) {
  const group = obj.userData?.swayGroup;
  if (!group) return;
  swayables.push({
    group,
    phase: Math.random() * Math.PI * 2,
    amount: obj.userData.swayAmount ?? 1,
  });
}

export function updateWind() {
  const t = performance.now() / 1000;
  // Global gust envelope. A very slow sine gives a baseline ebb-and-flow, and
  // the squared max() pulses layer stronger gusts on top every ~30 s or so.
  const gust = 0.85
    + 0.35 * Math.sin(t * 0.18)
    + 0.35 * Math.max(0, Math.sin(t * 0.09) * Math.sin(t * 0.27));

  for (const s of swayables) {
    // Two-axis sine so the wobble isn't a flat hinge. Amplitudes stay small —
    // it's a breeze, not a storm.
    s.group.rotation.x = Math.sin(t * 0.7 + s.phase)       * 0.025 * s.amount * gust;
    s.group.rotation.z = Math.cos(t * 0.5 + s.phase * 1.3) * 0.020 * s.amount * gust;
  }
}
